import React from 'react';

import { FlexDiv, GenericP } from 'commonStyles';
import Button from 'common/Button/Button';
import { DocsBannerHeading, DocsBannerWrapper } from './MybizDocsBannerStyles';
import { IntegrationSpriteIcons } from '../../../Style';

const MyBizDocsBanner = ({ bannerData = {}, btnHandler }) => {
	const { heading, subHeading, description, cta, imgUrl } = bannerData;

	return (
		<DocsBannerWrapper padding='84px 120px' $bg={`url(${imgUrl}) no-repeat, linear-gradient(95.43deg, #072833 0.23%, #092C46 100%)`} $direction='column' align='center'>
			<FlexDiv $width='1200px' $direction='column' justify='center' align='center' top_P='10' bottom_P='40'>
				{heading &&
				<DocsBannerHeading text_align='center' fsize='24px' f_weight='900'>
					{heading}
					<IntegrationSpriteIcons icon='sparklesIcon' />
				</DocsBannerHeading>}
				{subHeading &&
				<GenericP top_M='20' text_align='center' fsize='56px' f_weight='800' color='#fff'>
					{subHeading}
				</GenericP>}
				{description &&
				<GenericP padding='0 20px' text_align='center' fsize='20px' line_height='25px' color='#fff' top_M='20'>
					{description}
				</GenericP>}
				<Button
					margin='35px 0 0'
					btnTxt={cta}
					fontWeight='900'
					height='44px'
					btnFont='16px'
					btnType='Flat'
					btnName='Primary'
					btnShadow
					padding='10px 16px'
					btnWidth='auto'
					handleClick={btnHandler}
				/>
			</FlexDiv>

		</DocsBannerWrapper>
	);
};

export default MyBizDocsBanner;
